import client from "@/api";
import store from "@/store";
import { _rotaCategoriasMaisVendidas, _rotaCategoriasParents, _rotaGetCSVCategorias } from "@/api/_caminhosApi";

export function getCSV(from, to) {
  store.commit("interacoes/SET_LOADING", true);
  client
    .get(_rotaGetCSVCategorias(), {
      params: {
        from,
        to,
      },
      responseType: "blob",
    })
    .then(resp => {
      if (resp.status === 200) {
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `categorias.csv`);
        document.body.appendChild(link);
        link.click();
      }
    })
    .catch(erro => {
      console.log(erro);
    })
    .then(() => {
      store.commit("interacoes/SET_LOADING", false);
    });
}

export function listarCategoriasMaisVendidas(from, to, qtd, page) {
  store.commit("interacoes/SET_LOADING", true);
  store.commit("categorias/RESET_CATEGORIAS", null);
  client
    .get(`${_rotaCategoriasMaisVendidas()}`, {
      params: {
        from,
        to,
        per_page: qtd,
        page: page,
      },
    })
    .then(resp => {
      if (resp.status === 200) {
        store.commit("categorias/SET_CATEGORIAS", resp.data);
      }
    })
    .catch(erro => {
      console.log(erro);
    })
    .then(() => {
      store.commit("interacoes/SET_LOADING", false);
    });
}

export function listarCategoriasParents(from, to) {
  store.commit("interacoes/SET_LOADING", true);
  store.commit("categorias/RESET_CATEGORIAS_PARENTS", null);
  client
    .get(`${_rotaCategoriasParents()}`, {
      params: {
        from,
        to,
      },
    })
    .then(resp => {
      if (resp.status === 200) {
        store.commit("categorias/SET_CATEGORIAS_PARENTS", resp.data);
      }
    })
    .catch(erro => {
      console.log(erro);
    })
    .then(() => {
      store.commit("interacoes/SET_LOADING", false);
    });
}
